import React, {Component} from 'react';
import {SESSION_USER} from '../constants';
import AdminMenu from './AdminMenu';
import UserMenu from './UserMenu';

class NavMenu extends Component {


    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount(){

     }

    render(){
            let roleName='';
            let user = JSON.parse(localStorage.getItem(SESSION_USER));
            // console.log(user);
             if(user && user.roles){
                roleName=user.roles[0]
             }

    return (<aside className="left-sidebar">
          
             
            <div className="scroll-sidebar">
              
                <nav className="sidebar-nav">
                     {roleName=='ROLE_ADMIN'?<AdminMenu/>:''}
                      {roleName=='ROLE_USER'?<UserMenu/>:''}
                </nav>
               
            </div>
            
        </aside>);
  } 
}
export default NavMenu;
